export default function convertScale(value, source, target) {
  return ((value - source.min) / (source.max - source.min)) * (target.max - target.min) + target.min;
}
